import { render, staticRenderFns } from "./markers.vue?vue&type=template&id=204000a4&scoped=true&"
var script = {}
import style0 from "./markers.vue?vue&type=style&index=0&id=204000a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204000a4",
  null
  
)

export default component.exports